import { useTranslation } from 'butlerapp-integration/src/utils/translationService';
import type { NoDataToDisplayProps } from 'butlerapp-integration/src/components/NoDataToDisplay/NoDataToDisplay';
import { Alert, VStack } from '~/molecules';
import { HtmlContent as RenderHtml } from '~/components/RenderHtml';
import { StyleSheet } from 'react-native-unistyles';

export function NoDataToDisplay({ children, description, message }: NoDataToDisplayProps) {
    const { t } = useTranslation();
    return (
        <Alert status="warning">
            <VStack style={styles.content}>
                {message !== null ? <RenderHtml>{message || t('bookcart.no_data_to_display')}</RenderHtml> : null}
                {description ? <RenderHtml>{description}</RenderHtml> : null}
                {children}
            </VStack>
        </Alert>
    );
}

const styles = StyleSheet.create((theme) => ({
    content: {
        gap: theme.spacings['1'],
        width: '100%',
    },
}));
